module.exports = __webpack_public_path__ + "img/1center.aeeb217d.png";